import locales from "../locales";
import {OptionProps} from "antd/lib/select";

export const enum ItemType {
  DEVICE = 'DEVICE',
  SERVICE = 'SERVICE',
}

const itemTypeToText = {
  [ItemType.DEVICE]: locales.itemType_device,
  [ItemType.SERVICE]: locales.itemType_service,
};

export const getItemTypeOptions = (): OptionProps[] => [ItemType.DEVICE, ItemType.SERVICE].map(it => ({
  title: itemTypeToText[it],
  value: it,
}));


// WEBPACK FOOTER //
// ./src/item-details/itemType.tsx